"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const CodeView_1 = require("./CodeView");
const FloorView_1 = require("./FloorView");
const Footer_1 = require("./Footer");
const GameView_1 = require("./GameView");
const Header_1 = require("./Header");
const MapView_1 = require("./MapView");
const store_1 = require("./store");
const StoreView_1 = require("./StoreView");
const flex_scss_1 = __importDefault(require("./styles/flex.scss"));
const font_scss_1 = __importDefault(require("./styles/font.scss"));
const region_scss_1 = __importDefault(require("./styles/region.scss"));
const Transition_1 = require("./Transition");
function Root({ code }) {
    const iframeRef = React.useRef(null);
    const focusGame = React.useCallback(() => {
        if (iframeRef.current) {
            iframeRef.current.focus();
        }
    }, []);
    const editorMode = react_redux_1.useSelector((state) => state.mode.editorMode);
    return (React.createElement("div", { className: classnames_1.default(region_scss_1.default.root, flex_scss_1.default.vertical, font_scss_1.default.main) },
        React.createElement(Header_1.Header, null),
        React.createElement("div", { className: classnames_1.default(region_scss_1.default.outer, flex_scss_1.default.horizontal, flex_scss_1.default.stretch) },
            React.createElement("div", { className: region_scss_1.default.floor },
                React.createElement(FloorView_1.FloorView, null)),
            React.createElement("div", { className: classnames_1.default(region_scss_1.default.inner) },
                React.createElement(Transition_1.Transition, { in: editorMode === store_1.EditorMode.Map, className: region_scss_1.default.mapView, exiting: region_scss_1.default.exiting },
                    React.createElement(MapView_1.MapView, null)),
                React.createElement(Transition_1.Transition, { in: editorMode === store_1.EditorMode.Store, className: region_scss_1.default.storeView, exiting: editorMode === store_1.EditorMode.Map
                        ? region_scss_1.default.exitingRight
                        : region_scss_1.default.exitingLeft },
                    React.createElement(StoreView_1.StoreView, null)),
                React.createElement(Transition_1.Transition, { in: editorMode === store_1.EditorMode.Code, className: region_scss_1.default.codeView, exiting: region_scss_1.default.exiting },
                    React.createElement(CodeView_1.CodeView, { code: code, handleRun: focusGame }),
                    React.createElement("div", { className: region_scss_1.default.outputCover, onClick: focusGame }))),
            React.createElement(GameView_1.GameView, { iframeRef: iframeRef })),
        React.createElement(Footer_1.Footer, null)));
}
exports.Root = Root;
